import React, { useContext, useEffect } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

/* Material ui*/
import { useTheme, withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import { Switch } from '@material-ui/core';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { createTheme } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';

/* Icons */
import MenuIcon from '@material-ui/icons/Menu';
import Notifications from '@material-ui/icons/Notifications';
import SettingsIcon from '@material-ui/icons/Settings';
import { ReactComponent as Logout } from '../../assets/logout.svg';
import { ReactComponent as PersonalStatus } from '../../assets/personality.svg';
import { ReactComponent as History } from '../../assets/clock.svg';
import { ReactComponent as Graphics } from '../../assets/bar-graph.svg';
import { ReactComponent as Dashboard } from '../../assets/dashboard.svg';
import { ReactComponent as Help } from '../../assets/question.svg';
import { ReactComponent as Management } from '../../assets/management.svg';
import { ReactComponent as Alignment } from '../../assets/goal.svg';
import { ReactComponent as Tasks } from '../../assets/tasks.svg';
// import {ReactComponent as Analysis} from '../../assets/data-analysis.svg';

/*Colors*/
import { getColor } from '../../utils/genericFunctions';

/* Style */
import { useStyles } from './header.styles';

/* Api */
import { getMatchDateIF, ifStatus } from '../../api/ApiIF';
import { getUserNotifications } from '../../api/ApiUser';
import { findAllActiveUserTasks, getMatchMonthTasks } from '../../api/ApiTasks';
import {
    findAllActiveUserAlignments,
    getMatchMonthAlignments,
} from '../../api/ApiAlignment';

import { findNpsStatus } from '../../api/ApiNps';

/* Context */
import { authContext } from '../../contexts/AuthContext';

/* Permission */
import permissions, { getPermission } from '../../utils/permission';

const StyledSimpleBadge = withStyles((props) => ({
    margin: {
        margin: 1,
    },
    customBadgeOn: {
        backgroundColor: '#fff',
        color: '#000',
    },
}))(SimpleBadge);

export const StyledDrawer = withStyles({
    paper: {
        background: 'rgb(68, 68, 70)',
        '@media (max-width: 700px)': {
            width: 280,
        },
    },
})(SwipeableDrawer);

function SimpleBadge(props) {
    const { classes } = props;
    return (
        <IconButton component={Link} to="/notifications">
            <Badge
                classes={{ badge: classes.customBadgeOn }}
                className={classes.margin}
                badgeContent={props.badgeContent}
            >
                <Notifications
                    style={{ fontSize: props.mobile ? 30 : 32, fill: '#000' }}
                />
            </Badge>
        </IconButton>
    );
}

export default function PersistentDrawerLeft() {
    const { auth, setAuthData } = useContext(authContext);
    const [disabled, setDisabled] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [width, setWidth] = React.useState(500); //permission is the same way of width
    const [height, setHeight] = React.useState(500);
    const [tasksIpaSent, setTasksIpaSent] = React.useState(0);
    const [alignmentIpaSent, setAlignmentIpaSent] = React.useState(0);
    const [notificationsCount, setNotificationsCount] = React.useState(0);

    // disabled, sent, notSent
    const [npsStatus, setNpsStatus] = React.useState(null);

    const [ifAnswered, setIfAnswered] = React.useState(null);

    const theme = useTheme();
    const classes = useStyles();

    let history = useHistory();

    const outerTheme = createTheme({
        palette: {
            primary: {
                main: auth.data.system ? '#212121' : '#fff350',
                dark: '#ffc107',
                contrastText: '#212121',
            },
            secondary: {
                main: '#ff6922',
                dark: '#ff5722',
                contrastText: '#212121',
            },
        },
    });
    const onLogOut = () => {
        setAuthData(null);
    }; //clearing the context

    const updateDimensions = () => {
        if (window.innerWidth < 900) {
            setHeight(102);
            setWidth(450);
        } else {
            let update_width = window.innerWidth - 100;
            let update_height = Math.round(update_width / 4.4);
            setHeight(update_height);
            setWidth(update_width);
        }
    };

    useEffect(() => {
        const currentDate = new Date();
        if (currentDate.getDate() >= 8) {
            setDisabled(true);
        }
    }, []);

    useEffect(() => {
        const callApiFindAllAlignmentsPaged = async () => {
            const response = await findNpsStatus(
                auth,
                auth.data.user.userId,
                auth.data.user.companyId
            );

            const { message, payload } = await response.json();

            if (response.status !== 200) throw Error(message);

            setNpsStatus(payload[0].status);
        };

        try {
            callApiFindAllAlignmentsPaged();
        } catch (error) {
            console.log(error);
        }
    }, [auth]);

    useEffect(() => {
        const callApiIfAnswereds = async () => {
            const response = await ifStatus(
                auth,
                auth.data.user.userId,
                auth.data.user.companyId
            );

            const { message, payload } = await response.json();

            if (response.status !== 200) throw Error(message);

            setIfAnswered(payload[0].Answered);
        };

        try {
            callApiIfAnswereds();
        } catch (error) {
            console.log(error);
        }
    }, [auth]);

    useEffect(() => {
        const callApi = async () => {
            let actualYear = new Date().toISOString();
            actualYear = actualYear.split('-');
            let actualMonth = actualYear[1];
            let lastMonth; //the data will be save as the last month

            if (actualMonth === '01') {
                lastMonth = '12';
            } else {
                lastMonth = actualMonth - 1;
            }
            lastMonth = String(lastMonth);

            if (lastMonth.length === 1) {
                lastMonth = '0' + lastMonth;
            }

            const response = await getMatchDateIF(
                auth,
                auth.data.user,
                actualYear[0],
                lastMonth
            );

            //const response = await getMatchDateIF(auth, yearOfLastMonth, lastMonth);
            const body = await response.json();
            if (response.status !== 200) throw Error(body.message);

            return body.payload;
        };

        const callApiFindUserTasks = async (globalCompany, user) => {
            const response = await findAllActiveUserTasks(
                auth,
                globalCompany,
                user
            );
            const body = await response.json();

            if (response.status !== 200) throw Error(body.message);

            return body.payload;
        };

        const callApiMatchDate = async (globalCompany, data) => {
            const response = await getMatchMonthTasks(
                auth,
                data,
                globalCompany
            );
            const body = await response.json();

            if (response.status !== 200) throw Error(body.message);

            return body.payload;
        };

        const callApiFindUserAlignments = async (user, globalCompany) => {
            const response = await findAllActiveUserAlignments(
                auth,
                globalCompany,
                user
            );
            const body = await response.json();

            if (response.status !== 200) throw Error(body.message);

            return body.payload;
        };

        const callApiMatchDateAlignments = async (data, globalCompany) => {
            const response = await getMatchMonthAlignments(
                auth,
                data,
                globalCompany
            );
            const body = await response.json();

            if (response.status !== 200) throw Error(body.message);

            return body.payload;
        };

        const callFindUserNotifications = async (user, company) => {
            const response = await getUserNotifications(auth, user, company);
            const body = await response.json();

            if (response.status !== 200) throw Error(body.message);

            return body.payload;
        };

        updateDimensions();
        window.addEventListener('resize', updateDimensions.bind());

        let date = new Date().toISOString();
        date = date.split('-');

        let data = {
            user: auth.data.user.userId,
            month: date[1],
            year: date[0],
        };

        callFindUserNotifications(
            auth.data.user.userId,
            auth.data.user.companyId
        )
            .then((resNotifications) => {
                let count = 0;
                for (let i = 0; i < resNotifications.length; i++) {
                    if (resNotifications[i].situation === 'sent') count++;
                }
                setNotificationsCount(count);
            })
            .catch((err) => console.log(err));

        callApiFindUserTasks(auth.data.user.companyId, auth.data.user)
            .then((tasksRes) => {
                callApiMatchDate(auth.data.user.companyId, data)
                    .then((matchTaskRes) => {
                        let tempRows = [];
                        let tempValue;

                        for (let i = 0; i < tasksRes.length; i++) {
                            tempValue = matchTaskRes.filter(
                                (key) => key.taskId === tasksRes[i].taskId
                            );

                            if (tempValue.length === 0) {
                                tempRows[i] = {
                                    taskId: tasksRes[i].taskId,
                                    name: tasksRes[i].name,
                                    value: '',
                                    color: getColor(null),
                                };
                            } else {
                                tempRows[i] = {
                                    taskId: tasksRes[i].taskId,
                                    name: tasksRes[i].name,
                                    value: tempValue[0].grade,
                                    color: getColor(tempValue[0].grade),
                                };
                            }
                        }

                        for (let i = 0; i < tempRows.length; i++) {
                            if (tempRows[i].value !== '') {
                                setTasksIpaSent(1);
                            } else {
                                setTasksIpaSent(2);
                            }
                        }
                    })
                    .catch((err) => console.log(err));
            })
            .catch((err) => console.log(err));

        callApiFindUserAlignments(auth.data.user, auth.data.user.companyId)
            .then((alignmentsRes) => {
                callApiMatchDateAlignments(data, auth.data.user.companyId)
                    .then((monthAlignmentRes) => {
                        let tempRows = [];
                        let tempValue;

                        for (let i = 0; i < alignmentsRes.length; i++) {
                            tempValue = monthAlignmentRes.filter(
                                (key) =>
                                    key.alignmentId ===
                                    alignmentsRes[i].alignmentId
                            );

                            if (tempValue.length === 0) {
                                tempRows[i] = {
                                    alignmentId: alignmentsRes[i].alignmentId,
                                    name: alignmentsRes[i].name,
                                    value: '',
                                    color: getColor(null),
                                };
                            } else {
                                tempRows[i] = {
                                    alignmentId: alignmentsRes[i].alignmentId,
                                    name: alignmentsRes[i].name,
                                    value: tempValue[0].grade,
                                    color: getColor(tempValue[0].grade),
                                };
                            }
                        }

                        for (let i = 0; i < tempRows.length; i++) {
                            if (tempRows[i].value !== '') {
                                setAlignmentIpaSent(1);
                            } else {
                                setAlignmentIpaSent(2);
                            }
                        }
                    })
                    .catch((err) => console.log(err));
            })
            .catch((err) => console.log(err));

        callApi();
        return () => {
            window.removeEventListener('resize', updateDimensions.bind());
        };
    }, [width, height, auth]);

    const toggleDrawer = (open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }

        setOpen(open);
    };

    const ipaList = () => (
        <div
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            <div className={classes.drawerHeader}>
                {/*<ListItem style={{display: 'flex', justifyContent: 'center'}} button>*/}
                {/*    <Avatar style={{width: 50, height: 50}} src="../../assets/user.jpg"><img*/}
                {/*        style={{width: 50, height: 50}} src={User}/> </Avatar>*/}
                {/*</ListItem>*/}
                <IconButton onClick={toggleDrawer(false)}>
                    {theme.direction === 'ltr' ? (
                        <ChevronLeftIcon style={{ color: '#fff' }} />
                    ) : (
                        <ChevronRightIcon />
                    )}
                </IconButton>
            </div>
            <Divider />
            <List>
                {getPermission(
                    auth.data.permissions,
                    permissions.IPA_DASHBOARD
                ) ? (
                    <NavLink
                        to="/ipa/dashboard"
                        activeClassName={classes.active}
                    >
                        <ListItem button>
                            <ListItemIcon>
                                <Dashboard className={classes.iconLg} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Dashboard"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
                {getPermission(
                    auth.data.permissions,
                    permissions.IPA_SEND_ALIGNMENT
                ) ? (
                    <NavLink
                        to="/ipa/alignment"
                        activeClassName={classes.active}
                    >
                        <ListItem button>
                            {alignmentIpaSent === 1 ? (
                                <ListItemIcon>
                                    <Alignment
                                        style={{ fill: '#26a69a' }}
                                        className={classes.iconLg}
                                    />
                                </ListItemIcon>
                            ) : alignmentIpaSent === 2 ? (
                                <ListItemIcon>
                                    <Alignment
                                        style={{ fill: '#d32f2f' }}
                                        className={classes.iconLg}
                                    />
                                </ListItemIcon>
                            ) : (
                                <ListItemIcon>
                                    <Alignment
                                        style={{ fill: '#fff' }}
                                        className={classes.iconLg}
                                    />
                                </ListItemIcon>
                            )}
                            <ListItemText
                                className={classes.colorText}
                                primary="Alinhamento"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
                {getPermission(
                    auth.data.permissions,
                    permissions.IPA_SEND_TASKS
                ) ? (
                    <NavLink to="/ipa/tasks" activeClassName={classes.active}>
                        <ListItem button>
                            {tasksIpaSent === 1 ? (
                                <ListItemIcon>
                                    <Tasks
                                        style={{ fill: '#26a69a' }}
                                        className={classes.iconMd}
                                    />
                                </ListItemIcon>
                            ) : tasksIpaSent === 2 ? (
                                <ListItemIcon>
                                    <Tasks
                                        style={{ fill: '#d32f2f' }}
                                        className={classes.iconMd}
                                    />
                                </ListItemIcon>
                            ) : (
                                <ListItemIcon>
                                    <Tasks
                                        style={{ fill: '#fff' }}
                                        className={classes.iconMd}
                                    />
                                </ListItemIcon>
                            )}
                            <ListItemText
                                className={classes.colorText}
                                primary="Tarefas"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
                {/*<NavLink to='/monthly' activeClassName={classes.active}>*/}
                {/*    <ListItem button>*/}
                {/*        {exists ?*/}
                {/*            <ListItemIcon><PersonalStatus width='35' height='35' fill='#26a69a'/></ListItemIcon>*/}
                {/*            :*/}
                {/*            <ListItemIcon><PersonalStatus width='35' height='35' fill='#d32f2f'/></ListItemIcon>}*/}
                {/*        <ListItemText className={classes.colorText} primary='Enviar IF'/>*/}
                {/*    </ListItem>*/}
                {/*</NavLink>*/}

                <NavLink
                    to="/nps"
                    activeClassName={
                        npsStatus !== 'Fechado'
                            ? classes.active
                            : auth.data.user.permissionRoleId !== 2
                            ? classes.active
                            : null
                    }
                >
                    <ListItem button>
                        <ListItemIcon className={classes.colorText}>
                            <svg
                                className={classes.iconSm}
                                width="28"
                                height="12"
                                viewBox="0 0 28 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9.07129 1.04688V11H6.67871L3.1582 4.80664V11H0.758789V1.04688H3.1582L6.67871 7.24023V1.04688H9.07129Z"
                                    fill={
                                        npsStatus === 'Preenchido'
                                            ? '#26A69A'
                                            : npsStatus === 'Não preenchido'
                                            ? '#d32f2f'
                                            : '#ffffff'
                                    }
                                />
                                <path
                                    d="M14.5605 7.62305H12.0859V5.77051H14.5605C14.8978 5.77051 15.1712 5.71354 15.3809 5.59961C15.5905 5.48568 15.7432 5.32845 15.8389 5.12793C15.9391 4.92285 15.9893 4.69271 15.9893 4.4375C15.9893 4.16406 15.9391 3.91113 15.8389 3.67871C15.7432 3.44629 15.5905 3.25944 15.3809 3.11816C15.1712 2.97233 14.8978 2.89941 14.5605 2.89941H12.9883V11H10.5889V1.04688H14.5605C15.3581 1.04688 16.0439 1.19271 16.6182 1.48438C17.1969 1.77604 17.6413 2.17708 17.9512 2.6875C18.2611 3.19336 18.416 3.77214 18.416 4.42383C18.416 5.06641 18.2611 5.62695 17.9512 6.10547C17.6413 6.58398 17.1969 6.95768 16.6182 7.22656C16.0439 7.49089 15.3581 7.62305 14.5605 7.62305Z"
                                    fill={
                                        npsStatus === 'Preenchido'
                                            ? '#26A69A'
                                            : npsStatus === 'Não preenchido'
                                            ? '#d32f2f'
                                            : '#ffffff'
                                    }
                                />
                                <path
                                    d="M24.835 8.35449C24.835 8.19954 24.8122 8.06055 24.7666 7.9375C24.721 7.8099 24.6367 7.69141 24.5137 7.58203C24.3906 7.47266 24.2129 7.36328 23.9805 7.25391C23.7526 7.13997 23.4518 7.02148 23.0781 6.89844C22.6406 6.7526 22.2191 6.58854 21.8135 6.40625C21.4079 6.2194 21.0456 6.00293 20.7266 5.75684C20.4076 5.50618 20.1546 5.21452 19.9678 4.88184C19.7809 4.5446 19.6875 4.15267 19.6875 3.70605C19.6875 3.27767 19.7832 2.89258 19.9746 2.55078C20.166 2.20443 20.4326 1.91048 20.7744 1.66895C21.1208 1.42285 21.5264 1.236 21.9912 1.1084C22.4561 0.976237 22.9642 0.910156 23.5156 0.910156C24.2448 0.910156 24.8874 1.03776 25.4434 1.29297C26.0039 1.54362 26.4414 1.90137 26.7559 2.36621C27.0749 2.8265 27.2344 3.37109 27.2344 4H24.8486C24.8486 3.74935 24.7962 3.52832 24.6914 3.33691C24.5911 3.14551 24.4385 2.99512 24.2334 2.88574C24.0283 2.77637 23.7708 2.72168 23.4609 2.72168C23.1602 2.72168 22.9072 2.76725 22.7021 2.8584C22.4971 2.94954 22.3421 3.07259 22.2373 3.22754C22.1325 3.37793 22.0801 3.54427 22.0801 3.72656C22.0801 3.87695 22.1211 4.01367 22.2031 4.13672C22.2897 4.25521 22.4105 4.36686 22.5654 4.47168C22.7249 4.5765 22.9163 4.67676 23.1396 4.77246C23.3675 4.86816 23.6227 4.96159 23.9053 5.05273C24.4339 5.22135 24.9033 5.41048 25.3135 5.62012C25.7282 5.8252 26.0768 6.0599 26.3594 6.32422C26.6465 6.58398 26.863 6.88021 27.0088 7.21289C27.1592 7.54557 27.2344 7.92155 27.2344 8.34082C27.2344 8.78743 27.1478 9.18392 26.9746 9.53027C26.8014 9.87663 26.5531 10.1706 26.2295 10.4121C25.9059 10.6491 25.5186 10.8291 25.0674 10.9521C24.6162 11.0752 24.1126 11.1367 23.5566 11.1367C23.0462 11.1367 22.5426 11.0729 22.0459 10.9453C21.5537 10.8132 21.1071 10.6126 20.7061 10.3438C20.305 10.0703 19.9837 9.72168 19.7422 9.29785C19.5052 8.86947 19.3867 8.36133 19.3867 7.77344H21.793C21.793 8.0651 21.8317 8.3112 21.9092 8.51172C21.9867 8.71224 22.1006 8.87402 22.251 8.99707C22.4014 9.11556 22.5859 9.20215 22.8047 9.25684C23.0234 9.30697 23.2741 9.33203 23.5566 9.33203C23.862 9.33203 24.1081 9.28874 24.2949 9.20215C24.4818 9.111 24.6185 8.99251 24.7051 8.84668C24.7917 8.69629 24.835 8.53223 24.835 8.35449Z"
                                    fill={
                                        npsStatus === 'Preenchido'
                                            ? '#26A69A'
                                            : npsStatus === 'Não preenchido'
                                            ? '#d32f2f'
                                            : '#ffffff'
                                    }
                                />
                            </svg>{' '}
                        </ListItemIcon>
                        <ListItemText
                            className={classes.colorText}
                            primary="NPS"
                        />
                    </ListItem>
                </NavLink>
                {getPermission(
                    auth.data.permissions,
                    permissions.IPA_GRAPHS
                ) ? (
                    <NavLink to="/ipa/graphs" activeClassName={classes.active}>
                        <ListItem button>
                            <ListItemIcon>
                                <Graphics className={classes.iconSm} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Gráficos"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
                {/*</NavLink>*/}
                {/*<NavLink to='/graphics' activeClassName={classes.active}>*/}
                {/*    <ListItem button>*/}
                {/*        <ListItemIcon><Graphics className={classes.iconSm}/></ListItemIcon>*/}
                {/*        <ListItemText className={classes.colorText} primary='Gráficos'/>*/}
                {/*    </ListItem>*/}
                {/*</NavLink>*/}
            </List>
            <Divider />
            <List>
                {getPermission(
                    auth.data.permissions,
                    permissions.SYSTEM_USERS
                ) ? (
                    <NavLink
                        to="/management/users"
                        activeClassName={classes.active}
                    >
                        <ListItem button>
                            <ListItemIcon>
                                <Management className={classes.iconSm} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Gerenciamento"
                            />
                        </ListItem>
                    </NavLink>
                ) : getPermission(
                      auth.data.permissions,
                      permissions.IPA_RECORDS
                  ) ? (
                    <NavLink
                        to="/management/users"
                        activeClassName={classes.active}
                    >
                        <ListItem button>
                            <ListItemIcon>
                                <Management className={classes.iconSm} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Gerenciamento"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
                {/*<NavLink to='/help' activeClassName={classes.active}>*/}
                {/*    <ListItem button>*/}
                {/*        <ListItemIcon className={classes.colorText}><Help*/}
                {/*            className={classes.iconExtraSm}/></ListItemIcon>*/}
                {/*        <ListItemText className={classes.colorText} primary='Ajuda'/>*/}
                {/*    </ListItem>*/}
                {/*</NavLink>*/}

                {getPermission(
                    auth.data.permissions,
                    permissions.SYSTEM_CONFIGURATIONS
                ) ? (
                    <NavLink to="/settings" activeClassName={classes.active}>
                        <ListItem button>
                            <ListItemIcon className={classes.colorText}>
                                <SettingsIcon className={classes.iconSm} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Configurações"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
            </List>
        </div>
    );

    const ifList = () => (
        <div
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            <div className={classes.drawerHeader}>
                {/*<ListItem style={{display: 'flex', justifyContent: 'center'}} button>*/}
                {/*    <Avatar style={{width: 50, height: 50}} src="../../assets/user.jpg"><img*/}
                {/*        style={{width: 50, height: 50}} src={User}/> </Avatar>*/}
                {/*</ListItem>*/}
                <IconButton onClick={toggleDrawer(false)}>
                    {theme.direction === 'ltr' ? (
                        <ChevronLeftIcon style={{ color: '#fff' }} />
                    ) : (
                        <ChevronRightIcon />
                    )}
                </IconButton>
            </div>
            <Divider />
            <List>
                {getPermission(
                    auth.data.permissions,
                    permissions.IF_DASHBOARD
                ) ? (
                    <NavLink to="/dashboard" activeClassName={classes.active}>
                        <ListItem button>
                            <ListItemIcon>
                                <Dashboard className={classes.iconLg} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Dashboard"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
                {getPermission(auth.data.permissions, permissions.IF_SEND) ? (
                    <NavLink to="/monthly" activeClassName={classes.active}>
                        <ListItem
                            button
                            onClick={() =>
                                disabled ? window.location.reload() : '/monthly'
                            }
                        >
                            {ifAnswered === 1 ? (
                                <ListItemIcon>
                                    <PersonalStatus
                                        width="35"
                                        height="35"
                                        fill="#26a69a"
                                    />
                                </ListItemIcon>
                            ) : (
                                <ListItemIcon>
                                    <PersonalStatus
                                        width="35"
                                        height="35"
                                        fill="#d32f2f"
                                    />
                                </ListItemIcon>
                            )}
                            <ListItemText
                                className={classes.colorText}
                                primary="Enviar"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
                {getPermission(
                    auth.data.permissions,
                    permissions.IF_HISTORY
                ) ? (
                    <NavLink to="/history" activeClassName={classes.active}>
                        <ListItem button>
                            <ListItemIcon>
                                <History className={classes.iconSm} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Histórico"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
                {getPermission(auth.data.permissions, permissions.IF_GRAPHS) ? (
                    <NavLink to="/graphics" activeClassName={classes.active}>
                        <ListItem button>
                            <ListItemIcon>
                                <Graphics className={classes.iconSm} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Gráficos"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
                {/*<Link to='/analysis'>*/}
                {/*    <ListItem button>*/}
                {/*        <ListItemIcon><Analysis className={classes.iconMd}/></ListItemIcon>*/}
                {/*        <ListItemText className={classes.colorText} primary='Análises'/>*/}
                {/*    </ListItem>*/}
                {/*</Link>*/}
            </List>
            <Divider />
            <List>
                {/*//TODO adicionar permissão para o menu gerenciamento*/}
                {getPermission(
                    auth.data.permissions,
                    permissions.SYSTEM_USERS
                ) ? (
                    <NavLink
                        to="/management/users"
                        activeClassName={classes.active}
                    >
                        <ListItem button>
                            <ListItemIcon>
                                <Management className={classes.iconSm} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Gerenciamento"
                            />
                        </ListItem>
                    </NavLink>
                ): getPermission(
                    auth.data.permissions,
                    permissions.IPA_RECORDS
                ) ? (
                  <NavLink
                      to="/management/users"
                      activeClassName={classes.active}
                  >
                      <ListItem button>
                          <ListItemIcon>
                              <Management className={classes.iconSm} />
                          </ListItemIcon>
                          <ListItemText
                              className={classes.colorText}
                              primary="Gerenciamento"
                          />
                      </ListItem>
                  </NavLink>
              ): null}
                {getPermission(auth.data.permissions, permissions.IF_HELP) ? (
                    <NavLink to="/help" activeClassName={classes.active}>
                        <ListItem button>
                            <ListItemIcon className={classes.colorText}>
                                <Help className={classes.iconExtraSm} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Ajuda"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
                {getPermission(
                    auth.data.permissions,
                    permissions.SYSTEM_CONFIGURATIONS
                ) ? (
                    <NavLink to="/settings" activeClassName={classes.active}>
                        <ListItem button>
                            <ListItemIcon className={classes.colorText}>
                                <SettingsIcon className={classes.iconSm} />
                            </ListItemIcon>
                            <ListItemText
                                className={classes.colorText}
                                primary="Configurações"
                            />
                        </ListItem>
                    </NavLink>
                ) : null}
            </List>
        </div>
    );

    const handleChangeSystem = () => {
        if (auth.data.system) {
            history.push('/dashboard');
        } else {
            history.push('/ipa/dashboard');
        }

        setAuthData({
            token: auth.data.token,
            user: auth.data.user,
            system: !auth.data.system,
            permissions: auth.data.permissions,
        });
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            {width > 700 ? (
                <MuiThemeProvider theme={outerTheme}>
                    <AppBar
                        color={auth.data.system ? 'secondary' : 'primary'}
                        position="fixed"
                        className={clsx(classes.appBar, {
                            [classes.appBarShift]: open,
                        })}
                    >
                        <Toolbar>
                            <React.Fragment>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={toggleDrawer(true)}
                                    edge="start"
                                    className={clsx(classes.menuButton, {
                                        [classes.hide]: open,
                                    })}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </React.Fragment>

                            <FormControlLabel
                                value="start"
                                control={
                                    <Switch
                                        checked={auth.data.system === true}
                                        color="primary"
                                    />
                                }
                                label={
                                    <div className={classes.dot}>
                                        <span
                                            style={{
                                                fontSize: 18,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {auth.data.system ? 'IPA' : 'IF'}
                                        </span>
                                    </div>
                                }
                                onChange={handleChangeSystem}
                                labelPlacement="start"
                            />
                            <div className={classes.grow} />
                            <div className={classes.grow} />
                            <span
                                style={{
                                    fontSize: 16,
                                }}
                            >
                                {auth.data.user.name.split(' ')[0]}
                            </span>
                            <StyledSimpleBadge
                                badgeContent={notificationsCount}
                            />

                            <Button
                                style={{ backgroundColor: 'transparent' }}
                                onClick={onLogOut}
                            >
                                <div className={classes.dotButton}>
                                    <Logout
                                        style={{ fill: '#000' }}
                                        className={classes.iconSm}
                                    />
                                </div>
                            </Button>
                        </Toolbar>
                    </AppBar>
                </MuiThemeProvider>
            ) : (
                <MuiThemeProvider theme={outerTheme}>
                    <AppBar color={auth.data.system ? 'secondary' : 'primary'}>
                        <Toolbar>
                            <React.Fragment>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={toggleDrawer(true)}
                                    edge="start"
                                    className={clsx(
                                        classes.menuButton,
                                        open && classes.hide
                                    )}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <SwipeableDrawer
                                    open={open}
                                    onClose={toggleDrawer(false)}
                                    onOpen={toggleDrawer(true)}
                                    classes={{
                                        paper: classes.drawerPaper,
                                    }}
                                >
                                    {auth.data.system ? ipaList() : ifList()}
                                </SwipeableDrawer>
                            </React.Fragment>
                            <FormControlLabel
                                value="start"
                                control={
                                    <Switch
                                        checked={auth.data.system === true}
                                        color="primary"
                                    />
                                }
                                label={
                                    <div className={classes.dot}>
                                        <span
                                            style={{
                                                fontSize: 18,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {auth.data.system ? 'IPA' : 'IF'}
                                        </span>
                                    </div>
                                }
                                onChange={handleChangeSystem}
                                labelPlacement="start"
                            />
                            <div className={classes.grow} />
                            <div className={classes.grow} />

                            <StyledSimpleBadge
                                badgeContent={notificationsCount}
                                mobile={true}
                            />

                            <IconButton
                                className="logo-container"
                                aria-label="show 4 new mails"
                                color="inherit"
                                component={Button}
                                to="/notifications"
                                onClick={onLogOut}
                            >
                                <Logout
                                    style={{
                                        fill: '#000',
                                    }}
                                    className={classes.iconSm}
                                />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                </MuiThemeProvider>
            )}

            {width > 700 ? (
                <SwipeableDrawer
                    variant="permanent"
                    open={open}
                    onClose={toggleDrawer(false)}
                    onOpen={toggleDrawer(true)}
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    })}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                        }),
                    }}
                >
                    {auth.data.system ? ipaList() : ifList()}
                </SwipeableDrawer>
            ) : null}
        </div>
    );
}
